import { apiSlice } from "./apiSlice";

export const procurementDashboardSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => {
        return {

            getKpiData: builder.query({
                query: ({ projectId }) => ({
                    url: "Procurement/dashboard/important-kpis",
                    method: "GET",
                    params: { projectId },
                }),
            }),
            getProcurementServicePackage: builder.query({
                query: ({ projectId }) => ({
                    url: "Procurement/service-packages",
                    method: "GET",
                    params: { projectId },
                }),
            }),

            getWorkOrderByDepartment: builder.query({
                query: ({ projectId }) => ({
                    url: "Procurement/dashboard/work-orders-by-department",
                    method: "GET",
                    params: { projectId },
                }),
            }),

            getLongLeadItems: builder.query({
                query: ({ projectId }) => ({
                    url: "Procurement/dashboard/long-lead-items",
                    method: "GET",
                    params: { projectId },
                }),
            }),

            getAgeingAnalysisServices: builder.query({
                query: ({ projectId }) => ({
                    url: "Procurement/dashboard/ageing-analysis-services",
                    method: "GET",
                    params: { projectId },
                }),
            }),

            getAgeingAnalysisBoughtOutItems: builder.query({
                query: ({ projectId }) => ({
                    url: "Procurement/dashboard/ageing-analysis-bought-out-items",
                    method: "GET",
                    params: { projectId },
                }),
            }),

            getTopVendorsServices: builder.query({
                query: ({ projectId }) => ({
                    url: "Procurement/dashboard/top-vendors-services",
                    method: "GET",
                    params: { projectId },
                }),
            }),

            getTopVendorsBoughtOutItems: builder.query({
                query: ({ projectId }) => ({
                    url: "Procurement/dashboard/top-vendors-bought-out-items",
                    method: "GET",
                    params: { projectId },
                }),
            }),

            getProcurementStatusServices: builder.query({
                query: ({ projectId }) => ({
                    url: "Procurement/dashboard/procurement-status-services",
                    method: "GET",
                    params: { projectId },
                }),
            }),

            getProcurementStatusBoughtOutItems: builder.query({
                query: ({ projectId }) => ({
                    url: "Procurement/dashboard/procurement-status-bought-out-items",
                    method: "GET",
                    params: { projectId },
                }),
            }),

            getFloatingRfqDueThisMonth: builder.query({
                query: ({ projectId, startDate, endDate }) => ({
                    url: "Procurement/dashboard/floating-rfq-due-this-month",
                    method: "GET",
                    params: { projectId, startDate, endDate },
                }),
            }),

            getReleasePoThisWeek: builder.query({
                query: ({ projectId, startDate, endDate }) => ({
                    url: "Procurement/dashboard/release-po-due-this-week",
                    method: "GET",
                    params: { projectId, startDate, endDate },
                }),
            }),
            getServiceDetails: builder.query({
                query: (params) => ({
                    url: "Procurement/dashboard/services-details",
                    method: "GET",
                    params
                }),
            }),
            getBoughtOutItemDetails: builder.query({
                query: (params) => ({
                    url: "Procurement/dashboard/bought-out-items-details",
                    method: "GET",
                    params
                }),
            }),

        };
    },
});

export const {
    useGetKpiDataQuery,
    useGetWorkOrderByDepartmentQuery,
    useGetAgeingAnalysisServicesQuery,
    useGetAgeingAnalysisBoughtOutItemsQuery,
    useGetLongLeadItemsQuery,
    useGetTopVendorsServicesQuery,
    useGetTopVendorsBoughtOutItemsQuery,
    useGetProcurementStatusServicesQuery,
    useGetProcurementStatusBoughtOutItemsQuery,
    useGetFloatingRfqDueThisMonthQuery,
    useGetReleasePoThisWeekQuery,
    useGetProcurementServicePackageQuery,
    useGetServiceDetailsQuery,
    useLazyGetServiceDetailsQuery,
    useGetBoughtOutItemDetailsQuery,
    useLazyGetBoughtOutItemDetailsQuery
} = procurementDashboardSlice;
